export default function qrCodeWidget(Site, $) {
  Site.widget(
    'qr-code',
    {
      options: { code: false },
      async _transitionIn() {
        const text = `${this.options.code}`
        this.svg = $(`<svg class="image" id="key${this.uuid}"></svg>`)
        this.element.append(this.svg)

        if (!text) return

        const JSBarCode = (await import('jsbarcode')).default

        try {
          JSBarCode(
            `#key${this.uuid}`,
            text,
            {
              lineColor: '#26498D',
              background: '#0000',
              width: 2,
              height: 50
            }
          )
          this.element.addClass('ready')
        } catch (err) {
          console.log(err)
        }
      }
    }
  )
}